const normalizedCategory = category => typeof category === "string"
  ? category.trim().toUpperCase()
  : "";

const currentHostname = () => typeof window !== "undefined"
  ? window.location.hostname
  : "";

export const isNecoPurchaseOnlyHost = (hostname = currentHostname()) =>
  typeof hostname === "string" && hostname.trim().toLowerCase().startsWith("ug.nsuk");

export const getScratchCardOrganization = ssce => {
  const organizations = [ssce?.organization, ssce?.examType?.organization];
  const necoOrganizationWithId = organizations.find(organization =>
    normalizedCategory(organization?.category) === "NECO" && organization?.id != null
  );

  return necoOrganizationWithId
    || organizations.find(organization => organization?.id != null)
    || organizations.find(Boolean)
    || null;
};

export const isNecoSSCE = ssce => [
  ssce?.organization?.category,
  ssce?.examType?.organization?.category
].some(category => normalizedCategory(category) === "NECO");

const isForcedManualNecoSSCE = (ssce, hostname) =>
  isNecoSSCE(ssce) && !isNecoPurchaseOnlyHost(hostname);

export const hasCompletedScratchCardPin = pin => typeof pin === "string"
  ? pin.trim().length > 0
  : Boolean(pin);

export const hasCompletedScratchCardSSCE = ssce => hasCompletedScratchCardPin(ssce?.scratchCardPin);

export const getPurchaseScratchCardSSCEs = (
  ssces = [],
  automaticPurchasesEnabled = false,
  hostname = currentHostname()
) => ssces.filter(ssce => isNecoSSCE(ssce)
  ? isNecoPurchaseOnlyHost(hostname)
  : automaticPurchasesEnabled && !ssce.manualScratchCard
);

export const getManualScratchCardSSCEs = (ssces = [], hostname = currentHostname()) => {
  const manualEligibleSSCEs = ssces.filter(ssce =>
    !isNecoSSCE(ssce) || !isNecoPurchaseOnlyHost(hostname)
  );
  const explicitlyManualSSCEs = manualEligibleSSCEs.filter(ssce =>
    ssce.manualScratchCard || isForcedManualNecoSSCE(ssce, hostname)
  );

  return explicitlyManualSSCEs.length > 0 ? explicitlyManualSSCEs : manualEligibleSSCEs;
};

export const hasPendingPurchaseScratchCardSSCE = (
  ssces = [],
  automaticPurchasesEnabled = false,
  hostname = currentHostname()
) => getPurchaseScratchCardSSCEs(ssces, automaticPurchasesEnabled, hostname)
    .some(ssce => !hasCompletedScratchCardSSCE(ssce));

export const hasPendingManualScratchCardSSCE = (
  ssces = [],
  manualCollectionEnabled = false,
  hostname = currentHostname()
) => {
  const manualSSCEs = manualCollectionEnabled
    ? getManualScratchCardSSCEs(ssces, hostname)
    : ssces.filter(ssce =>
      (!isNecoSSCE(ssce) && ssce.manualScratchCard)
      || isForcedManualNecoSSCE(ssce, hostname)
    );

  return manualSSCEs.some(ssce => !hasCompletedScratchCardSSCE(ssce));
};

export const areScratchCardDetailsComplete = ({
  ssces = [],
  automaticPurchasesEnabled = false,
  manualCollectionEnabled = false,
  hostname = currentHostname()
} = {}) => {
  if (ssces.length === 0) return !manualCollectionEnabled;

  return !hasPendingPurchaseScratchCardSSCE(ssces, automaticPurchasesEnabled, hostname)
    && !hasPendingManualScratchCardSSCE(ssces, manualCollectionEnabled, hostname);
};
